import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const PuttingTitle = () => {
  const { t } = useTranslation('training');
  
  return (
    <motion.div 
      initial={{
        opacity: 0,
        y: 20
      }} 
      animate={{
        opacity: 1,
        y: 0
      }} 
      transition={{
        duration: 0.5
      }} 
      className="text-center mb-12"
    >
      <h1 className="text-4xl font-bold text-golf-800 mb-4">
        {t('putting.title')}
      </h1>
      <p className="text-xl text-golf-600">
        {t('putting.description')}
      </p>
    </motion.div>
  );
};
export default PuttingTitle;